import { render } from "./Cabinet.vue?vue&type=template&id=5a64e7c8&scoped=true"
import script from "./Cabinet.vue?vue&type=script&lang=js"
export * from "./Cabinet.vue?vue&type=script&lang=js"

import "./Cabinet.vue?vue&type=style&index=0&id=5a64e7c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a64e7c8"]])

export default __exports__